import React, { ComponentProps, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Form, Option, Row, Select, SelectParam, SonForm, SubmitButton, useForm } from '../../_lib/Form2';
import { BlockType } from '../../types/api/ElementType';
import { translatePartOfStringWithLink } from '../../lib/StringUtils/StringHTMLUtils';
import { Namespace } from '../../translation/namespace';

type ContentColorScheme = 'standard' | 'dark' | 'light';

type ColorSchemeSettingsProps = {
  reloadUrl: string;
  colorSchemeSettingsForm: SonForm<SelectParam<'colorScheme', { value: ContentColorScheme }>>;
};

function ColorSchemeSettings({ reloadUrl, colorSchemeSettingsForm }: ColorSchemeSettingsProps) {
  const { t } = useSonTranslation('ColorSchemeSettings');
  const navigate = useNavigate();

  const reloadPageOnSuccess = () => {
    setTimeout(() => navigate(0), 2000);
  };

  const { formProps, params, fetchState } = useForm({
    form: colorSchemeSettingsForm,
    onSuccess: reloadPageOnSuccess as any,
  });

  const colorSchemeParam = params.getByName('colorScheme');

  const getReloadMessage = (): ReactNode => {
    return translatePartOfStringWithLink(`${Namespace.ColorSchemeSettings}:successReloadMessage`, reloadUrl, false);
  };

  return (
    <Form {...formProps}>
      <Row>
        <Select key={colorSchemeParam.value} label={t('inputs.colorScheme.label')} param={colorSchemeParam}>
          {colorSchemeParam.options.map(option => (
            <Option key={option.value} value={option.value} selected={option.value === colorSchemeParam.value}>
              {t(`inputs.colorScheme.options.${option.value}`)}
            </Option>
          ))}
        </Select>
      </Row>
      <SubmitButton
        buttonLabel={t('saveSettings')}
        messageSuccess={getReloadMessage()}
        messageSending={t(`sending`)}
        messageFail={t('fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const ColorSchemeSettingsBlock = asFetchableBlock(ColorSchemeSettings, BlockType.colorschemesettings);
export type ColorSchemeSettingsBlock = ComponentProps<typeof ColorSchemeSettingsBlock>;
